import styled from 'styled-components'
import { borderRadiusFromControlSize } from 'utils/src/control-size'
import MediaNavigation from '../../controls/media/navigation'
import { CONTROL_SIZE } from '../constants'

export const Navigation = styled(MediaNavigation)`
    border-radius: ${borderRadiusFromControlSize(CONTROL_SIZE)}px;
`
